import { useMemo } from "react";
function useErrorsByChild(fieldErrors) {
  return useMemo(() => {
    const errors = fieldErrors.reduce((acc, error) => {
      if (typeof error.index !== "number") return acc;
      acc[error.index] ??= [];
      acc[error.index].push(error);
      return acc;
    }, []);
    for (const childErrors of errors) {
      childErrors.sort(({ priority: a = 0 }, { priority: b = 0 }) => b - a);
    }
    return errors;
  }, [fieldErrors]);
}
export {
  useErrorsByChild
};
//# sourceMappingURL=useErrorsByChild.js.map
